export const normalizeString = (stringProp) =>
  stringProp
    .toLowerCase()
    .normalize('NFD')
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '');

export const extractTextByRegex = (text, regex) => {
  if (!text) return '';
  const result = text.match(regex);
  return result ? result.join('') : '';
};

export const pluralize = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

export default normalizeString;
